import { observable } from 'mobx'
import * as moment from 'moment'

export default class userProjectsStore {
  @observable data = []
  @observable sessionData = []
  @observable sessionsDataByDate = []
  @observable created = false
  @observable readingTrackDataSetId = ''
  @observable userId = ''
  @observable issueId = ''
  @observable delId = ''
  @observable delDate = ''

  updateData(data) {
    this.data = data
  }

  updateSessionData(data) {
    this.sessionData = data
  }

  updateCreated() {
    this.created = true
  }

  updatesessionsDataByDate(date) {
    this.sessionsDataByDate = this.data.filter(
      d =>
        moment(new Date(d.date)).format('l') ===
        moment(new Date(date)).format('l')
    )
  }

  updatesessionsDataById(issueId, projectId, issueName) {
    this.issueId = issueId
    this.sessionsDataByDate = this.data.filter(
      d =>
        d.issueId === issueId &&
        d.projectId === projectId &&
        d.issueName === issueName
    )
  }
}



// WEBPACK FOOTER //
// ./src/stores/userProjectsStore.js